

import { Badge } from '@/components/ui/badge';

interface BillingPeriodSelectorProps {
  selectedPeriod: 'monthly' | 'annual';
  onPeriodChange: (period: 'monthly' | 'annual') => void;
}

export function BillingPeriodSelector({ selectedPeriod, onPeriodChange }: BillingPeriodSelectorProps) {
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="flex rounded-lg border-2 border-gray-300 p-1 shadow-sm">
        <button
          onClick={() => onPeriodChange('monthly')}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            selectedPeriod === 'monthly'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          Monthly
        </button>
        <button
          onClick={() => onPeriodChange('annual')}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors relative ${
            selectedPeriod === 'annual'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          Annual
          <Badge
            variant="secondary"
            className="absolute -top-4 -right-2 text-xs bg-purple-100 text-purple-800"
          >
            Save 20%
          </Badge>
        </button>
      </div>
    </div>
  );
}
